import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as RegisterActions from 'auth/store/actions/index';
import * as DataActions from 'store/actions/medprocure/index';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles/index';
import { Button, Card, CardContent, Typography, MenuItem, CircularProgress } from '@material-ui/core';
import classNames from 'classnames';

const styles = theme => ({
    root: {
    },
    progress: {
        color: '#1976d2'
    }
});

class Landing extends Component {

    constructor(props) {
        super(props);
        let search = window.location.search;
        let params = new URLSearchParams(search);
        let sessionKey = params.get('sessionKey')
        this.props.checkSessionKey(sessionKey);
        localStorage.setItem("portalToken", sessionKey)
    }

    render() {
        const { classes } = this.props;
        return (
            <div style={{ height: '100vh', width: '100%', backgroundColor: '#f0f0f0', margin: '0px' }}>
                <div style={{ width: '100px', height: '100px', backgroundColor: '#f0f0f0', position: 'absolute', top: '0', bottom: '0', left: '0', right: '0', margin: 'auto' }}>
                    <CircularProgress
                        className={classes.progress}
                        size={50}
                        value={50}
                        color={'primary'}
                    />
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        checkSessionKey: RegisterActions.checkSessionKey
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth: auth
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Landing)));


// WEBPACK FOOTER //
// src/main/content/auth/Landing.js